import { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";

import { useUsers } from "~/hooks";
import { User } from "~/shared.types";

const getInitials = (user: User) => {
  return `${user.firstName.charAt(0).toUpperCase()}${user.lastName.charAt(0).toUpperCase()}`;
};

export const Avatar = () => {
  const { getCurrentUser } = useUsers();

  const { data: currentUser } = getCurrentUser();

  const [initials, setInitials] = useState<string>();

  useEffect(() => {
    if (currentUser) {
      setInitials(getInitials(currentUser));
    }
  }, [currentUser]);

  if (!initials) {
    return (
      <Skeleton
        className="rounded-full"
        width={40}
        height={40}
        borderRadius={"100%"}
      />
    );
  }

  return (
    <span
      aria-hidden="true"
      className="text-indigo bg-lightLavender inline-flex size-10 flex-none cursor-pointer items-center justify-center rounded-full text-[16px] font-normal"
    >
      {initials}
    </span>
  );
};
